import baseStyles from '../Base/Base.styles';
import baseTextStyles from '../BaseText/BaseText.styles';
import {responsiveTextAlignment} from '../Base/responsiveAlignment';

export default ({base, title, typerText}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '& .text': {
        ...baseTextStyles(title),
        ...responsiveTextAlignment(base.alignment),
      },
      '& .typer': baseTextStyles(typerText),
      '& .cursor': baseTextStyles(typerText),
    },
  };

  console.log(jss);
  return jss;
};
